"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
const useMutateCustomProperties = _ref => {
  let {
    afterQueryCalls,
    catchQueryCalls,
    endpoint,
    id,
    queryParams,
    returnQueryObject = {
      post: false,
      put: false,
      delete: false
    }
  } = _ref;
  const returnObj = {};
  const ky = (0, _core.useOkapiKy)();
  const deleteQueryObject = (0, _reactQuery.useMutation)(['stripes-kint-components', 'useMutateCustomProperties', 'delete', id], async () => ky.delete("".concat(endpoint, "/").concat(id)).json().then(afterQueryCalls === null || afterQueryCalls === void 0 ? void 0 : afterQueryCalls.delete).catch(catchQueryCalls === null || catchQueryCalls === void 0 ? void 0 : catchQueryCalls.delete), queryParams === null || queryParams === void 0 ? void 0 : queryParams.delete);
  const putQueryObject = (0, _reactQuery.useMutation)(['stripes-kint-components', 'useMutateCustomProperties', 'put', id], async data => ky.put("".concat(endpoint, "/").concat(id), {
    json: data
  }).json().then(afterQueryCalls === null || afterQueryCalls === void 0 ? void 0 : afterQueryCalls.put).catch(catchQueryCalls === null || catchQueryCalls === void 0 ? void 0 : catchQueryCalls.put), queryParams === null || queryParams === void 0 ? void 0 : queryParams.put);
  const postQueryObject = (0, _reactQuery.useMutation)(['stripes-kint-components', 'useMutateCustomProperties', 'post'], async data => ky.post("".concat(endpoint), {
    json: data
  }).json().then(afterQueryCalls === null || afterQueryCalls === void 0 ? void 0 : afterQueryCalls.post).catch(catchQueryCalls === null || catchQueryCalls === void 0 ? void 0 : catchQueryCalls.post), queryParams === null || queryParams === void 0 ? void 0 : queryParams.post);
  if (returnQueryObject !== null && returnQueryObject !== void 0 && returnQueryObject.delete) {
    returnObj.delete = deleteQueryObject;
  } else {
    returnObj.delete = deleteQueryObject.mutateAsync;
  }
  if (returnQueryObject !== null && returnQueryObject !== void 0 && returnQueryObject.put) {
    returnObj.put = putQueryObject;
  } else {
    returnObj.put = putQueryObject.mutateAsync;
  }
  if (returnQueryObject !== null && returnQueryObject !== void 0 && returnQueryObject.post) {
    returnObj.post = postQueryObject;
  } else {
    returnObj.post = postQueryObject.mutateAsync;
  }
  return returnObj;
};
var _default = exports.default = useMutateCustomProperties;